module.exports = __webpack_public_path__ + "static/media/about_summer.b9563d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_summer.jpg
// module id = 868
// module chunks = 0